import {lazy} from 'react';
import {createUseStyles} from 'react-jss';
import Page from './enums/Page';

import useGlobalStyles from './GlobalStyles.styles';
import PaymentHiddenOrDisabledListener from './listeners/PaymentHiddenOrDisabledListener';
import PageFooter from './sections/PageFooter/PageFooter';
import PageHeader from './sections/PageHeader/PageHeader';
import GenericFallbackSuspense from './v2/components/ui/GenericFallback/GenericFallbackSuspense';
import getPage from './v2/page/getPage';

export const LazyCheckoutPage = lazy(() => import('./pages/CheckoutPage/CheckoutPage' /* webpackChunkName: 'CheckoutPage' */));
export const LazyCompletePage = lazy(() => import('./pages/CompletePage/CompletePage' /* webpackChunkName: 'CompletePage', webpackPrefetch: -100 */));
export const LazyOrderProcessingPage = lazy(() => import('./pages/OrderProcessingPage/OrderProcessingPage' /* webpackChunkName: 'OrderProcessingPage' */));
export const LazyPaymentChangedPage = lazy(() => import('./pages/PaymentChangedPage/PaymentChangedPage' /* webpackChunkName: 'PaymentChangedPage' */));
export const LazyPaymentChangePage = lazy(() => import('./pages/PaymentChangePage/PaymentChangePage' /* webpackChunkName: 'PaymentChangePage' */));
export const LazyPaymentResolutionPage = lazy(() => import('./pages/PaymentResolutionPage/PaymentResolutionPage' /* webpackChunkName: 'PaymentResolutionPage' */));
export const LazyPaymentResolvedPage = lazy(() => import('./pages/PaymentResolvedPage/PaymentResolvedPage' /* webpackChunkName: 'PaymentResolvedPage' */));

const useStyles = createUseStyles({
  wrap: {
    maxWidth: 960,
    margin: [0, 'auto'],
  },
});

export default function CheckoutApp() {
  useGlobalStyles();
  const classes = useStyles();
  
  const lazyPage = () => {
    switch (getPage()) {
      case Page.PAYMENT_CHANGE:
        return <LazyPaymentChangePage />;
      case Page.PAYMENT_CHANGED:
        return <LazyPaymentChangedPage />;
      case Page.PAYMENT_RESOLUTION:
        return <LazyPaymentResolutionPage />;
      case Page.PAYMENT_RESOLVED:
        return <LazyPaymentResolvedPage />;
      case Page.COMPLETE:
        return <LazyCompletePage />;
      case Page.PROCESSING:
        return <LazyOrderProcessingPage />;
      default:
        return <LazyCheckoutPage />;
    }
  };
  
  return (
    <>
      <PageHeader />
      <div className={classes.wrap}>
        <GenericFallbackSuspense>
          {lazyPage()}
        </GenericFallbackSuspense>
      </div>
      <PageFooter />
      <PaymentHiddenOrDisabledListener />
    </>
  );
}
